import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {SubAccount} from 'src/app/models/sub-account';
import {GlobalLoaderService} from '../../services/global-loader.service';
import {ApiAgentService} from '../../services/api-agent.service';
import {NewSubAccountComponent} from './new-sub-account/new-sub-account.component';
import {SubAccountsPaymentFormComponent} from './sub-accounts-payment-form/sub-accounts-payment-form.component';
import {NewSubAccountCountResponse} from '../../models/new-sub-account-count-response';
import {FormGroup, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {checkStatus, NewSubAccountRequest} from '../../models/new-sub-account-request';
import {Router, RouterModule} from '@angular/router';
import {decodeBase64} from '../private.component';
import {CommonModule} from '@angular/common';

declare var $: any;

@Component({
  selector: 'app-sub-accounts',
  templateUrl: './sub-accounts.component.html',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule, SubAccountsPaymentFormComponent, NewSubAccountComponent, RouterModule],
  styleUrls: ['./sub-accounts.component.scss']
})
export class SubAccountsComponent implements OnInit {

  @ViewChild('newSubAccountModal') newSubAccountModal: NewSubAccountComponent;
  @ViewChild('subAccountsPaymentForm') subAccountsPaymentForm: SubAccountsPaymentFormComponent;
  @ViewChild('infoModal') infoModal: ElementRef;
  loading: boolean;
  subAccounts: SubAccount[];
  form: FormGroup;
  modalTitle: any;
  modalMsg: any;

  constructor(private loader: GlobalLoaderService,
              private routing: Router,
              private translate: TranslateService,
              private api: ApiAgentService) {
  }

  ngOnInit(): void {
    this.reloadData();
  }

  reloadData(): void {
    this.loading = true;
    setTimeout(async () => {
      await this.loadResources();
      this.subAccounts = await this.api.getSubAccounts();
      console.log('sub accounts', this.subAccounts);
      this.loading = false;
    }, 1000);
  }


  private async loadResources() {
    await this.loader.loadExternalStyles('/assets/css/forms/theme-checkbox-radio.css');
    await this.loader.loadExternalStyles('/plugins/jquery-ui/jquery-ui.min.css');
    await this.loader.loadExternalStyles('/assets/css/apps/contacts.css');
    await this.loader.loadExternalScript('/plugins/jquery-ui/jquery-ui.min.js');
  }

  viewUsed(newSubAccountRequest: NewSubAccountRequest) {
    this.routing.navigateByUrl('/private/assign-sub-accounts/' + newSubAccountRequest.id + '/sub-accounts').then();
  }

  async openNewSubAccountModal() {
    // check if there is a not used request.
    let subAccountRequests = await this.api.getSubAccountRequests();
    console.log('sub accounts request', subAccountRequests);

    let foundNonUsedRequest = false;
    for (let subAccountRequestsKey of subAccountRequests) {
      let status = checkStatus(subAccountRequestsKey);
      if (status == 'Ready To Use') {
        console.log('open the request to add the sub account', subAccountRequestsKey);
        foundNonUsedRequest = true;
        this.viewUsed(subAccountRequestsKey);
        break;
      }
    }

    if (!foundNonUsedRequest) {
      // if there are no request
      this.newSubAccountModal.openModal();
    }
  }

  async unlockSubAccount(subAccount: SubAccount) {
    await this.api.postUnlockSubAccount(subAccount);
    this.reloadData();
  }

  async lockSubAccount(subAccount: SubAccount) {
    await this.api.postLockSubAccount(subAccount);
    this.reloadData();
  }

  newSubAccountModalResponseReceived(newSubAccountCountResponse: NewSubAccountCountResponse) {
    if (newSubAccountCountResponse.approved) {
      this.subAccountsPaymentForm.loadData(newSubAccountCountResponse)
        .then(value => {
          if (value) {
            this.newSubAccountModal.closeModal();
            this.subAccountsPaymentForm.openModal();
          }
        }).catch(error => {
        this.newSubAccountModal.closeModal();
        alert(error);
      });
    } else if (newSubAccountCountResponse.approvalRequestNo) {
      this.modalTitle = 'Request submitted';
      this.translate.get('The request has been submitted for approval. The request no is:').toPromise().then(value => {
        this.modalMsg = value + newSubAccountCountResponse.approvalRequestNo;
        $(this.infoModal.nativeElement).modal('show');
        this.newSubAccountModal.closeModal();
      });
    }
  }

  private replaceSubAccount(subAccount: SubAccount) {
    // Find the index of the subAccount to be replaced
    const index = this.subAccounts.findIndex(item => item.id === subAccount.id);
    // If the subAccount with the given id exists in the array, replace it
    if (index !== -1) {
      this.subAccounts = [
        ...this.subAccounts.slice(0, index), // Keep the items before the replaced item
        subAccount, // Insert the new subAccount object
        ...this.subAccounts.slice(index + 1) // Keep the items after the replaced item
      ];
    }
  }

  async triggerAccountant(assignedSubAccount: SubAccount) {
    await this.api.postTriggerAccountant(assignedSubAccount);
    // window.location.reload();
    this.reloadData();
  }

  async triggerSales(assignedSubAccount: SubAccount) {
    await this.api.postTriggerSales(assignedSubAccount);
    // window.location.reload();
    this.reloadData();
  }

  isAccountant(assignedSubAccount: SubAccount) {
    if (assignedSubAccount.accountType) {
      let accountTypeValue = decodeBase64(assignedSubAccount.accountType);
      return this.containsSpecificString(accountTypeValue, 'Accountant') ? 'checked' : '';
    } else {
      return '';
    }
  }

  isSales(assignedSubAccount: SubAccount) {
    if (assignedSubAccount.accountType) {
      let accountTypeValue = decodeBase64(assignedSubAccount.accountType);
      return this.containsSpecificString(accountTypeValue, 'Sales') ? 'checked' : '';
    } else {
      return 'checked';
    }
  }


  containsSpecificString(value: string, searchString: string): boolean {
    return value.includes(searchString);
  }

  getStyle(assignedSubAccount: SubAccount) {
    return {
      'text-decoration': assignedSubAccount.enabled ? 'none' : 'line-through',
      'text-decoration-color': assignedSubAccount.enabled ? 'red' : ''
    };
  }
}
